import Note from "./Note";
import CreateNoteArea from "./CreateNoteArea";
import { useGetNotesQuery } from "./notesApiSlice";
import { Stack, CircularProgress } from "@mui/material";

function NotesList() {
  const {
    data: notes,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetNotesQuery("notesList", {
    pollingInterval: 60000,
    refetchOnFocus: true,
    refetchOnMountOrArgChang: true,
  });
  let content;
  if (isLoading) {
    content = (
      <Stack alignItems="center">
        <CircularProgress
          sx={{
            display: "block",
            textAlign: "center",
            marginLeft: "550px",
          }}
        />
      </Stack>
    );
  }

  if (isError) {
    if (error.data.message === "No notes found!") {
      content = (
        <div>
          <CreateNoteArea />
        </div>
      );
    } else {
      content = <p className="errmsg">{error?.data?.message}</p>;
    }
  }
  if (isSuccess) {
    const { ids } = notes;
    const mainContent = ids?.length ? (
      <>
        <CreateNoteArea />
        {ids?.map((noteId) => (
          <Note key={noteId} id={noteId} />
        ))}
      </>
    ) : (
      <CreateNoteArea />
    );
    content = <div>{mainContent}</div>;
  }
  return content;
}

export default NotesList;
